var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgForwardEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-inline--fa fa-fw",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33337 5.83334L8.20003 9.48333C9.2667 10.2833 10.7334 10.2833 11.8 9.48333L16.6667 5.8333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.8333H4.5C3.39543 15.8333 2.5 14.9379 2.5 13.8333V6.16667C2.5 5.0621 3.39543 4.16667 4.5 4.16667H15.5C16.6046 4.16667 17.5 5.0621 17.5 6.16667V10",
    stroke: "currentColor",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 14.1667L17.5 14.1667M17.5 14.1667L15.8334 15.8333M17.5 14.1667L15.8334 12.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardEmail);
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9InN2Zy1pbmxpbmUtLWZhIGZhLWZ3IiB2aWV3Qm94PSIwIDAgMjAgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0zLjMzMzM3IDUuODMzMzRMOC4yMDAwMyA5LjQ4MzMzQzkuMjY2NyAxMC4yODMzIDEwLjczMzQgMTAuMjgzMyAxMS44IDkuNDgzMzNMMTYuNjY2NyA1LjgzMzMiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEwIDE1LjgzMzNINC41QzMuMzk1NDMgMTUuODMzMyAyLjUgMTQuOTM3OSAyLjUgMTMuODMzM1Y2LjE2NjY3QzIuNSA1LjA2MjEgMy4zOTU0MyA0LjE2NjY3IDQuNSA0LjE2NjY3SDE1LjVDMTYuNjA0NiA0LjE2NjY3IDE3LjUgNS4wNjIxIDE3LjUgNi4xNjY2N1YxMCIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTMuMzMzNCAxNC4xNjY3TDE3LjUgMTQuMTY2N00xNy41IDE0LjE2NjdMMTUuODMzNCAxNS44MzMzTTE3LjUgMTQuMTY2N0wxNS44MzM0IDEyLjUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };